import { ContactBottomPanel } from './ContactBottomPanel.component'
import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(ContactBottomPanel)

export { withUnmountHoc as ContactBottomPanel }
